import { render, staticRenderFns } from "./UpdateableImage.vue?vue&type=template&id=1ded7388&scoped=true"
import script from "./UpdateableImage.vue?vue&type=script&lang=ts"
export * from "./UpdateableImage.vue?vue&type=script&lang=ts"
import style0 from "./UpdateableImage.vue?vue&type=style&index=0&id=1ded7388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded7388",
  null
  
)

export default component.exports